import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Observable, throwError } from "rxjs";
// import { map, catchError } from 'rxjs/operators';
import * as CryptoJS from "crypto-js";
import * as Base64 from "crypto-js/enc-base64";
import { environment } from "../../../environments/environment";
import { any } from '@amcharts/amcharts4/.internal/core/utils/Array';
// import { LayoutService } from 'src/app/shared/services/layout.service';

@Injectable()
export class AuthenticationService {
  private authURL = environment.serverIP;
  private users = "api/users/";
  private getIPApi="get_ip/";
  copyrightYear: BehaviorSubject<string> = new BehaviorSubject(
    new Date().getFullYear().toString()
  );
  ErrorMessage: BehaviorSubject<string> = new BehaviorSubject("");

  httpOptions = {
    headers: new HttpHeaders({
      Pragma: "no-cache",
      "Cache-Control": "no-cache, no-store, max-age=0, must-revalidate",
    }),
  };
  constructor(private http: HttpClient) {}

  HMACGeneration(userKey, secretKey, args): Observable<any> {
    return new Observable((observer) => {
      this.getPublicIPAddress().subscribe(
        (data) => {
          let endPointResult:any;
          let response: any = data;
          if (response.status == "ok") {
            let method = args.method;
            let timestamp = new Date().toISOString();
            let endPoint = args.endPoint;
            if(args.parameters){
              let dataArg = JSON.stringify(args.parameters);
              endPointResult = `${method}\n${response.ip}\n${endPoint}\n${timestamp}\n${dataArg}`;
            }
            else{
              endPointResult = `${method}\n${response.ip}\n${endPoint}\n${timestamp}\n`;
            }
            let generatedHMAC = CryptoJS.algo.HMAC.create(
              CryptoJS.algo.SHA256,
              `${JSON.parse(secretKey)}`
            );
            generatedHMAC.update(endPointResult);
            let HMAC = Base64.stringify(generatedHMAC.finalize());
            observer.next({
              status: "ok",
              HMAC_Sign: HMAC,
              user_key: JSON.parse(userKey),
              timeStamp: timestamp,
            });
            observer.complete();
          } else {
            this.ErrorMessage.next("Something went wrong");
            observer.next({ status: "error" });
            observer.complete();
          }
        },
        (err) => {
          this.ErrorMessage.next("Something went wrong");
          observer.next({ status: "error", err: err });
          observer.complete();
        }
      );
    });
  }

  loginUser(credentials): Observable<any> {
    return new Observable((observer) => {
      this.http
        .post(
          this.authURL + "api-token-auth/",
          { username: credentials.userName, password: credentials.password },
          this.httpOptions
        )
        .subscribe(
          (data) => {
            let response: any = data;
            // console.log(response);
            if (response && response.token) {
              observer.next({ status: "ok", token: response.token });
              observer.complete();
            } else {
              observer.next({ status: "error" });
              observer.complete();
            }
          },
          (err) => {
            this.ErrorMessage.next(
              "Service Temporarily Unavailable, please try again"
            );
            observer.next({ status: "error", err: err });
            observer.complete();
          }
        );
    });
  }

  getUserByEmail(params): Observable<any> {
    return new Observable((observer) => {
      this.http.get(`${this.users}`, params).subscribe((data) => {
        if (data) {
          observer.next({ status: "ok", user: data });
          observer.complete();
        }
      });
    });
  }

  getPublicIPAddress(): Observable<any> {
    return new Observable((observer) => {
      // observer.next({ status: "ok", ip: '202.47.35.64' });
      // observer.complete();
      this.http.get(this.authURL + this.getIPApi ,this.httpOptions ).subscribe(
        (data) => {
          let response: any = data;
          // console.log(response);
          
          if (response) {
            // console.log("ip",response);
            
            observer.next({ status: "ok", ip: response });
            observer.complete();
          } else {
            observer.next({ status: "error" });
            observer.complete();
          }
        },
        (err) => {
          this.ErrorMessage.next("Internal Server Error");
          observer.next({ status: "error", code: 500 });
          observer.complete();
        }
      );
    });
  }

  public getCopyrightYear(): Observable<string> {
    return this.copyrightYear.asObservable();
  }

  Logout() {
    sessionStorage.removeItem("currentUser_EPC_Portfolio");
    sessionStorage.removeItem("secretKey");
    sessionStorage.removeItem("userKey");
  }
}
